import React, { useState, useEffect } from "react";
import { Box, TextField, Button, Typography, MenuItem, FormControl, InputLabel, Select, Grid } from "@mui/material";

const HotelRewardPointsForm = ({ handleClose, onSubmit, initialData, hotels, eventTypes }) => {
  const [formData, setFormData] = useState({
    hotel_id: "",
    event_type: "",
    reward_points: "",
    from_value: "",
    to_value: "",
    no_of_points: "",
    status: "1",
    date_expired: ""
  });

  // Set initial form data when editing
  useEffect(() => {
    if (initialData) {
      console.log("Setting initial form data:", initialData);
      
      // Convert hotel_id to string if it's a number
      const hotel_id = initialData.hotel_id ? initialData.hotel_id.toString() : "";
      
      // Convert status to string if it's a number
      // Check if status exists in initialData and handle different formats
      let status = "1";
      if (initialData.status !== undefined) {
        status = typeof initialData.status === 'number' || typeof initialData.status === 'string' 
          ? initialData.status.toString() 
          : "1";
      }
      
      // Format date if needed
      let formattedDate = "";
      if (initialData.date_expired) {
        try {
          // Try to parse and format the date
          const date = new Date(initialData.date_expired);
          if (!isNaN(date.getTime())) {
            formattedDate = date.toISOString().split('T')[0];
          } else {
            formattedDate = initialData.date_expired;
          }
        } catch (e) {
          console.error("Error formatting date:", e);
          formattedDate = initialData.date_expired;
        }
      }
      
      const newFormData = {
        hotel_id: hotel_id,
        event_type: initialData.event_type || "",
        reward_points: initialData.reward_points || "",
        from_value: initialData.from_value || "",
        to_value: initialData.to_value || "",
        no_of_points: initialData.no_of_points || "",
        status: status,
        date_expired: formattedDate
      };
      
      console.log("Form data being set:", newFormData);
      setFormData(newFormData);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {initialData ? "Edit Reward Points" : "Add New Reward Points"}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          
          <FormControl fullWidth margin="normal">
            <InputLabel id="hotel-label">Hotel</InputLabel>
            <Select
              labelId="hotel-label"
              name="hotel_id"
              value={formData.hotel_id}
              onChange={handleChange}
              label="Hotel"
              required
            >
              {hotels.length > 0 ? (
                hotels
                .filter(hotel => hotel.is_active === true)
                .map((hotel) => {
                  // Use hotel.hotel_id instead of hotel.id if that's what your data has
                  const hotelIdStr = hotel.hotel_id ? hotel.hotel_id.toString() : 
                                  (hotel.id ? hotel.id.toString() : "");
                  return (
                    <MenuItem key={hotelIdStr} value={hotelIdStr}>
                      {hotel.name}
                    </MenuItem>
                  );
                })
              ) : (
                <MenuItem value="">No hotels available</MenuItem>
              )}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth margin="normal">
            <InputLabel id="event-type-label">Event Type</InputLabel>
            <Select
              labelId="event-type-label"
              name="event_type"
              value={formData.event_type}
              onChange={handleChange}
              label="Event Type"
              required
            >
              {eventTypes.map((type, index) => (
                <MenuItem key={index} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            margin="normal"
            label="Reward Points"
            name="reward_points"
            value={formData.reward_points}
            onChange={handleChange}
            type="number"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            margin="normal"
            label="From Value"
            name="from_value"
            value={formData.from_value}
            onChange={handleChange}
            type="number"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            margin="normal"
            label="To Value"
            name="to_value"
            value={formData.to_value}
            onChange={handleChange}
            type="number"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            margin="normal"
            label="No of Points"
            name="no_of_points"
            value={formData.no_of_points}
            onChange={handleChange}
            type="number"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth margin="normal">
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              labelId="status-label"
              name="status"
              value={formData.status || "1"}
              onChange={handleChange}
              label="Status"
              defaultValue="1"
            >
              <MenuItem value="1">Active</MenuItem>
              <MenuItem value="0">Inactive</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            margin="normal"
            label="Expiry Date"
            name="date_expired"
            value={formData.date_expired || ""}
            onChange={handleChange}
            type="date"
            InputLabelProps={{ shrink: true }}
            inputProps={{ max: "9999-12-31" }}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" type="submit" color="primary">
          {initialData ? "Update" : "Save"}
        </Button>
      </Box>
    </Box>
  );
};

export default HotelRewardPointsForm;
